import { render, staticRenderFns } from "./PurchaseSuccessful.vue?vue&type=template&id=b380888a&lang=pug&"
import script from "./PurchaseSuccessful.vue?vue&type=script&lang=js&"
export * from "./PurchaseSuccessful.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseSuccessful.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports